import React from 'react';
import PropTypes from 'prop-types';
import {
  Transfers,
  Receivables,
  Refunds,
  TransfersHover,
  ReceivablesHover,
  RefundsHover,
} from 'common/components/svgs';

export default class BillingCard extends React.Component {
  choiceRoleSvg = type => {
    switch (type) {
      case 'transfers':
        return Transfers;
      case 'receivables':
        return Receivables;
      case 'refunds':
        return Refunds;
      case 'transfers-hover':
        return TransfersHover;
      case 'receivables-hover':
        return ReceivablesHover;
      case 'refunds-hover':
        return RefundsHover;
      default:
        return React.Fragment;
    }
  };
  render() {
    const { t, type } = this.props;
    const SvgComp = this.choiceRoleSvg(type);
    const SvgHoverComp = this.choiceRoleSvg(type + '-hover');
    return (
      <div className={`billing__card billing__${type}`}>
        <SvgHoverComp className="billing__card-icon" />
        <SvgComp className="billing__card-icon--gray" />
        <div className="billing__card-text">
          <h3 className="billing__card-title">{t(`cms.billing.${type}.title`)}</h3>
          <span className="billing__card-description">{t(`cms.billing.${type}.desc`)}</span>
        </div>
      </div>
    );
  }
}

BillingCard.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.string,
};

BillingCard.defaultProps = {
  t: () => {},
  type: '',
};
